import { Assessment } from "./assessments";

export enum DatabaseAction {
    Association         = 'association',
    Create              = 'create',
    AddNew              = 'new',
    Replace             = 'replace',
    Archive             = 'archive',
    Edit                = 'edit',
    EnableTimesheets    = 'enabled timesheets',
    Update              = 'update',
    NewVersion          = 'newversion',
    Assessment          = 'assessment',
    DocReview           = 'document review',
    WorkflowRequest     = 'workflow request',
    Provision           = 'provision',
    CriticalDate        = 'critical date',
    Attachment          = 'attachment',
    Notes               = 'notes',
    DataTable           = 'data table',
    NewAssociation      = 'new association',
    NewVersionAdded     = 'version list updated'
}

export enum EntityState {
    Active    = 'active',
    Replaced  = 'replaced',
    Archived  = 'archived',
    DocReview = 'docreview',
    Retired   = 'retired',
    Superseded = 'superseded',
    Terminated = 'terminated'
}


export enum QuestionGroup {
    PhysicianEmploymentAgreement = 'Phsycian Employment Agreement',

}




export enum EntityType {
  Contract = 'contract',
  Coi = 'coi',
  Baa = 'baa',
  Party = 'party',
  Person = 'person',
  User = 'user',
  Attachment = 'attachment',
  Provision = 'provision',
  Assessment = 'assessment',
  Date = 'date',
  Site = 'sites',
  Timesheet = 'timesheet',
  Timecard = 'timecard',
  Workflow = 'workflow',
  LegalEntity = 'legalentity'
}

export enum TimesheetSubmitStates {
    Draft       = 'draft',
    Submitted   = 'submitted',
    Approved    = 'approved',
    Rejected    = 'rejected',
    Paid        = 'paid'
}

/**
 * Canonical submission status vocabulary (unified redesign, §3) — the wire
 * contract shared by both products and both Flutter apps.
 *
 *   draft → submitted → under_review → approved → pending_payment → paid
 *   (+ rejected, from submitted/under_review)
 *
 * Timesheets use the full set. Timecards stop at `Approved` (no payment stage,
 * §4) and never emit `PendingPayment`/`Paid`. The legacy `TimesheetSubmitStates`
 * / `TimesheetReviewStates` and the old timecards strings
 * (pending_review/pending_approval/returned) are RETIRED — use these instead.
 */
export enum SubmissionStatus {
    Draft           = 'draft',
    Submitted       = 'submitted',
    UnderReview     = 'under_review',
    Approved        = 'approved',
    PendingPayment  = 'pending_payment',
    Paid            = 'paid',
    Rejected        = 'rejected'
}

export enum TimesheetSpecStates {
    Draft       = 'draft',
    Active      = 'active',
    Inactive    = 'inactive'
}

export enum TimesheetReviewStates {
    Draft               = 'draft',
    PendingReview       = 'pending',
    ReviewerApproved    = 'approved',
    ReviewerRejected    = 'rejected',
}

export enum WorkflowTypes {
    Request     = 'request',
    Document    = 'document',
    Attachment  = 'attachment'
}

export enum WorkflowStatus {
    Requested   = 'Requested',
    Open        = 'Open',
    Finalized   = 'Finalized',
    Suspended   = 'Suspended',
    Canceled   = 'Canceled',
    Pending     = 'Pending',
    Approved    = 'Approved',
    Signatures  = 'Signatures',
    InReview    = 'In Review'
}

export enum WorkflowPhases {
    PhaseI      = 'Phase I - Requested',
    PhaseII     = 'Phase II - Assembly',
    PhaseIII    = 'Phase III - Review & Approval',
    PhaseIV     = 'Phase IV - Signature',
    PhaseV      = 'Phase V - Out for Signature',
    PhaseVI     = 'Phase VI - Fully Executed'
}

export interface EditEvent {
    editor: string;
    date: string;
    entityType: EntityType;
    changes?: object[];  // key value pairs of what properties were changed
}

export interface User {
    firstName?: string;
    lastName?: string;
    email: string;
    friendlyName: string;
}

